export default __webpack_public_path__ + "static/generalproduct-f056fe17dacd20f39540a06d110d48d4.png";